<template>
    <div>
        <jet-confirmation-modal
            :show="registerWallet && !confirm2FARegister"
            :maxWidth="'md'"
            :animation="'top'"
            :position-modal="'center'"
            :scroll="false"
            @close="$emit('close')"
        >
            <template #title>
                <div class="w-full">
                    <div class="text-black text-opacity-70 font-bold text-xl">
                        Cadastrar nova wallet
                    </div>
                    <hr class="mt-1 w-full" />
                </div>
            </template>

            <template #content>
                <div>
                    <div class="mb-4">
                        <label-form :text="'Moeda'" />
                        <jet-auto-complete
                            :auto-load="true"
                            :endpoint="'cripto/new-currencies'"
                            v-model="form.currency"
                            @input="form.hash && validateWalletAddress(form.hash)"
                        />
                    </div>
                    <div class="mb-4">
                        <text-field
                            :label="'Rede'"
                            :placeholder="'Selecione uma moeda'"
                            :value="form.currency?.network.toUpperCase()"
                            :disabled="true"
                        />
                        <jet-input-error :message="form.error('network')"/>
                    </div>
                    <div class="mb-4">
                        <text-field
                            v-model="form.name"
                            placeholder="Digite um apelido para sua wallet"
                            label="Nome da wallet"
                        />
                        <jet-input-error
                            :message="fieldErrors.name || form.error('name')"
                        />
                    </div>
                    <div class="mb-4">
                        <text-field
                            placeholder="Hash"
                            label="Hash"
                            v-model="form.hash"
                            @input="validateWalletAddress"
                        />
                        <jet-input-error
                            :message="fieldErrors.hash || form.error('hash')"
                        />
                    </div>
                </div>
            </template>

            <template #footer>
                <div class="flex justify-between">
                    <secondary-button @click.native="$emit('close')">
                        Cancelar
                    </secondary-button>
                    <div v-tippy="enableButtonRegister ? 'Para habilitar, preencha todos os campos' : ''">
                        <primary-button
                            :is-disabled="enableButtonRegister"
                            @click.native="!enableButtonRegister ? confirm2FARegister = true : null"
                            >Confirmar
                        </primary-button>
                    </div>
                </div>
            </template>
        </jet-confirmation-modal>

        <jet-confirmation-modal
            :show="confirm2FARegister"
            :scroll="false"
            :position-modal="'center'"
            @close="confirm2FARegister = false; $emit('close')"
        >
            <template #title>
                <div class="w-full">
                    <div class="text-black text-opacity-70 font-bold text-xl">
                        <i
                            class="p-2 text-gray-600 fas fa-arrow-left cursor-pointer"
                            @click="confirm2FARegister = false"
                        />
                        Confirmar titularidade
                    </div>
                    <hr class="mt-1 w-full" />
                </div>
            </template>
            <template #content>
                <div class="my-4">
                    <p class="mb-5">
                        Para cadastrar esta wallet é necessário confirmar a sua titularidade.
                    </p>
                    <label for="holder" class="flex gap-x-3 items-center mb-5">
                        <input id="holder" type="checkbox" v-model="isHolder">
                        <label-form
                            class="sm:text-sm sm:mb-0"
                            :text="'Declaro que sou o titular da wallet cadastrada.'"
                        />
                    </label>
                    <text-field
                        :label="'Código de autorização'"
                        :placeholder="'Digite o código 2FA'"
                        :type="'numeric'"
                        :max-length="6"
                        :disabled="!isHolder"
                        v-model="form.google_code"
                    />
                    <jet-input-error :message="form.error('google_code')" />
                </div>
            </template>
            <template #footer>
                <div class="flex justify-between">
                    <secondary-button @click.native="confirm2FARegister = false; $emit('close')">
                        Cancelar
                    </secondary-button>
                    <div v-tippy="form?.google_code?.length !== 6 ? 'Digite um código 2FA válido para habilitar' : ''">
                        <primary-button
                            :is-disabled="form?.google_code?.length !== 6 || !isHolder"
                            @click.native="form?.google_code?.length === 6 ? save() : null"
                            >
                            <i v-show="form.processing" class="fas fa-spinner animate-spin mr-2" /> Confirmar
                        </primary-button>
                    </div>
                </div>
            </template>
        </jet-confirmation-modal>

        <jet-confirmation-modal
            :show="confimWalletDelete"
            :animation="'top'"
            :scroll="false"
            :position-modal="'center'"
            @close="$emit('close')"
        >
            <template #title>
                <div class="w-full">
                    <div class="text-black text-opacity-70 font-bold text-xl">
                        Remover wallet
                    </div>
                    <hr class="mt-1 w-full" />
                </div>
            </template>
            <template #content>
                <div class="mt-2 mb-4">
                    <p class="mb-5">
                        Deseja mesmo remover a wallet
                        <b>{{ selectedWallet.name }}</b
                        >? Para confirmar insira o código 2FA abaixo:
                    </p>
                    <text-field
                        :label="'Código de autorização'"
                        :placeholder="'Digite o código 2FA'"
                        :type="'numeric'"
                        :max-length="6"
                        v-model="formDelete.google_code"
                    />
                    <jet-input-error :message="formDelete.error('google_code')" />
                </div>
            </template>
            <template #footer>
                <div class="flex justify-between">
                    <secondary-button @click.native="$emit('close')">
                        Cancelar
                    </secondary-button>
                    <primary-button
                        :is-disabled="formDelete?.google_code?.length !== 6"
                        @click.native="formDelete?.google_code?.length === 6 ? removeWallet() : null"
                        >Confirmar
                    </primary-button>
                </div>
            </template>
        </jet-confirmation-modal>
    </div>
</template>

<script>
import JetConfirmationModal from "../../../Jetstream/ConfirmationModal.vue";
import PrimaryButton from "../../../Jetstream/PrimaryButton.vue";
import SecondaryButton from "../../../Jetstream/SecondaryButton.vue";
import TextField from "./../components/TextField.vue";
import JetInputError from "../../../Jetstream/InputError.vue";
import DropdownSelect from "./../components/DropdownSelect.vue";
import Icons from "./../components/Icons.vue";
import LabelForm from './../components/Label.vue'
import JetAutoComplete from '../../../Jetstream/AutoComplete.vue';
import WalletAddressValidator from 'multicoin-address-validator';
export default {
    props: {
        confimWalletDelete: {
            type: Boolean,
            default: false
        },
        registerWallet: {
            type: Boolean,
            default: false
        },
        selectedWallet: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        enableButtonRegister(){
            return !(this.form.currency && this.form.name && this.form.hash && !this.fieldErrors.hash)
        }
    },
    methods: {
        validateWalletAddress(walletAddress) {
            const network = this.form.currency?.network;
            const valid = WalletAddressValidator.validate(walletAddress, network)
            if (!valid){
                return this.fieldErrors.hash = "Hash da carteira invalido."
            }
            this.fieldErrors.hash = "";
        },
        removeWallet() {
            this.formDelete.post(
                `/crypto/wallet/destroy/${this.selectedWallet.id}`,
                {
                    resetOnSuccess: true,
                    onSuccess: () => {
                        this.confimWalletDelete = false
                    }
                }
            );
        },
        save() {
            this.fieldErrors.hash = null;
            this.fieldErrors.name = null;

            if (this.form.processing) return;
            if (!/[a-z0-9]/gi.test(this.form.hash)) {
                this.fieldErrors.hash = "Caracteres inválidos.";
                return;
            }
            if (!/[a-z0-9_\s]/gi.test(this.form.name)) {
                this.fieldErrors.name = "Caracteres inválidos.";
                return;
            }

            this.form.name = this.form.name
                .normalize("NFD")
                .replace(/[^a-zA-Z_0-9\s]/g, "");

            const endpoint = "/crypto/wallet";
            this.form._method = "POST";
            this.form.post(endpoint, {
                resetOnSuccess: true,
                onSuccess: e => {
                    this.form.reset();
                    this.isHolder = false;
                    this.confirm2FARegister = false;
                    this.form.processing = false;
                    this.$emit('close')
                },
                onError: e => {
                    this.form.processing = false;
                }
            });
        }
    },
    watch: {
        confimWalletDelete() {
            if(!this.confimWalletDelete) this.formDelete.reset()
        },
        registerWallet() {
            if(!this.registerWallet)this.form.reset()
        },
    },
    data() {
        return {
            confirm2FARegister: false,
            isHolder: false,
            cryptos: [],
            fieldErrors: {
                hash: null,
                name: null
            },
            form: this.$inertia.form({
                currency: null,
                network: null,
                name: null,
                hash: null,
                google_code: null
            }),
            formDelete: this.$inertia.form({
                id: null,
                google_code: null
            }),
        };
    },
    components: {
        JetConfirmationModal,
        PrimaryButton,
        SecondaryButton,
        TextField,
        JetInputError,
        DropdownSelect,
        Icons,
        LabelForm,
        JetAutoComplete
    },
};
</script>
